import { render, staticRenderFns } from "./MasterclassBadges.vue?vue&type=template&id=515b2fdc&scoped=true&"
import script from "./MasterclassBadges.vue?vue&type=script&lang=js&"
export * from "./MasterclassBadges.vue?vue&type=script&lang=js&"
import style0 from "./MasterclassBadges.vue?vue&type=style&index=0&id=515b2fdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515b2fdc",
  null
  
)

export default component.exports